import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Tickets from "../dummy-data.json";
import { MessagePart } from "./MessagePart";
import BreadCrum from "./BreadCrum";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSingleTicket, closeTicket } from "../utilities/userauth";
import { getingsingleTicket, sendreplyy } from "../TicketAction";
import { useSelector } from "react-redux";
import { Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchTickets } from "../TicketAction";

export const TicketPage = () => {
  const dispatch = useDispatch();
  const { tId } = useParams();
  const navigate = useNavigate();

  //for gettign the variables from the redux
  const { selectedTicket, isLoading } = useSelector((state) => state.tickets);
  const {
    user: { name },
  } = useSelector((state) => state.userinfo);

  // const Ticket = Tickets[0];
  const [comment, setComment] = useState("");
  const [Ticket, setTicket] = useState(Tickets[0]);
  // console.log("----", typeof Ticket);

  useEffect(() => {
    dispatch(getingsingleTicket(tId));
  }, [dispatch]);
  const commentHandler = (e) => {
    const { value } = e.target;
    setComment(value);
  };

  const ReplyHandler = (e) => {
    e.preventDefault();
    // alert(comment);
    console.log(comment);
    //sending a reply handlers
    const msgobj = {
      sender: name,
      message: comment,
    };
    dispatch(sendreplyy(tId, msgobj));
    dispatch(getingsingleTicket(tId));
    setComment("");
  };

  const CloseTicketHandler = async () => {
    alert("Are you sure to close this ticket ?");

    const close = await closeTicket(tId);
    dispatch(fetchTickets());
    navigate("/dashboard");
  };

  // console.log("Ticket", Ticket);
  // console.log("history", Ticket.history);
  if (isLoading) {
    return <Spinner variant="primary" animation="border" mt="2" />;
  }
  return (
    <div>
      <BreadCrum Data="Ticket Page" />
      <h3>Ticket Page</h3>
      <Button variant="danger" onClick={CloseTicketHandler}>
        Close This Ticket
      </Button>
      <Row>
        <Col>
          <p>
            Ticket Id for Refrence RTM-<b>{tId}</b>
          </p>

          <h5>Subject : {selectedTicket.subject}</h5>
          <h5>Status : {selectedTicket.status}</h5>
          <h5>Date : {selectedTicket.openAt}</h5>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          {selectedTicket.conversation ? (
            <MessagePart Data={selectedTicket.conversation} />
          ) : (
            <p>Nothing message</p>
          )}
        </Col>
      </Row>
      <Row>
        <Form onSubmit={ReplyHandler}>
          <Form.Control
            row="5"
            type="textarea"
            placeholder="please type here the comment please........."
            onChange={commentHandler}
            value={comment}
          />
          <div className="mt-3 mb-3">
            <Button type="submit" variant="info">
              Reply
            </Button>
          </div>
        </Form>
      </Row>
    </div>
  );
};
